// extracted by mini-css-extract-plugin
module.exports = {"label-content":"style_label-content__1TNAo"};